import { deleteApi, get, post } from "../GenericServices";

const User = {
  getUserSuppliers: (queryString) => {
    return get(`user/supplier?${queryString}`);
  },
  saveUserSupplier: (data) => {
    return post("user/supplier", data);
  },
  getUsersInternalList: (queryString) => {
    return get(`user/internal?${queryString}`);
  },
  saveInternalUser: (data) => {
    return post(`user/internal`, data);
  },
  saveInternalUserEdit: (id, data) => {
    return post(`user/internal/${id}`, data);
  },
  getUserData: (username) => {
    return get(`user/${username}`);
  },
  loginMasterUser: (queryString) => {
    return get(`user/login-master-users?${queryString}`);
  },
  exportInternalUsersCsv: () => {
    return get("user/internal/report");
  },
  exportSupplierUsersCsv: () => {
    return get("user/supplier/report");
  },
  getValidSubstituteUsersList: () => {
    return get(`user/expense-refund-to-substitute`);
  },
  getValidSubstituteUsers: (username) => {
    return get(`user/valid_to_substitute_users/${username}`);
  },
  getValidexpenseRefundUserToSubstituteUsers: (username) => {
    return get(`user/valid-expense-refund-to-substitute-users/${username}`);
  },
  getUsersInternalHrList: (queryString) => {
    return get(`user/internal-hr?${queryString}`);
  },
  getSalSubstituteAbilitations: (username) => {
    return get(`user/${username}/sal-substitute-abilitations`);
  },
  setSalSubstituteAbilitations: (username, data) => {
    return post(`user/${username}/sal-substitute-abilitations`, data);
  },
  deleteSalSubstituteAbilitations: (username, id) => {
    return deleteApi(`user/${username}/sal-substitute-abilitations/${id}`);
  },
  getSalSubstituteSuppliers: () => {
    return get(`user/sal-substitute/suppliers`);
  },
  getSalSubstitutePhases: (supplierUsername) => {
    return get(`user/sal-substitute/suppliers/${supplierUsername}/wbs-categories`);
  },
  getSalSubstituteTasks: (supplierUsername, projectPhaseId) => {
    return get(`user/sal-substitute/suppliers/${supplierUsername}/project-phases/${projectPhaseId}/wbs`);
  },
};

export default User;
